module.exports = "@media (max-width: 320px) {\n  .display-3 {\n    font-size: 4em; } }\n"